import './open-positions.css';
import {v4 as uuid} from 'uuid';
import { IPosition } from '../../common/apply-form/interfaces/IOpenPosition';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleUp, faHandPeace, faHourglassHalf, faSquareCheck } from '@fortawesome/free-regular-svg-icons';
import { faFlagCheckered, faPersonWalkingArrowRight, faStar } from '@fortawesome/free-solid-svg-icons';
import ApplyFormComponent from '../../common/apply-form/apply-form.component';
import { useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { RootState } from '../../../state/store';
import { useSelector } from 'react-redux';

const OpenPositionsComponent = () => {
    const phrases = useSelector((state: RootState) => state.phrases.value);
    const formElementRef = useRef<any>();
    const expandBtnRef = useRef<any>();
    const collapseBtnRef = useRef<any>();

    const positions: Array<IPosition> = [
        // Uncomment and change values to show open position.

        // {
        //     title: "Software Developer",
        //     jobDescription: "Develop and maintain software.",
        //     projectDescription: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusantium alias eveniet dicta repellat recusandae et vitae labore consequuntur, laborum voluptas.",
        //     requiredSkills: [
        //         "3+ years of work experience;",
        //         "Good understanding of OOP, Data Structures and Algorithms;",
        //         "Proficiency with .NET;", 
        //         "Proficiency with C# and JavaScript;", 
        //         "Experience with front-end frameworks preferably React and Angular;",
        //         "Good knowledge of Git - experience with branching, merging, squashing;",
        //         "Communication skills;",
        //         "Experience with Jira and Agile methodology.",
        //     ],
        //     niceToHaveSkills: [
        //         "Experience with Docker;",
        //         "Experience with Terraform;",
        //         "Experience with Cloud services;",
        //         "Knowledge of Linux and bash scripting."
        //     ],
        //     advantages: [
        //         "Master or Bachelor degree in Computer Sciences, Mathematics, Physics or equivalent work experience;",
        //         "Internships;",
        //         "AWS certificates are big plus.",
        //     ],
        //     offerings: [
        //         "Competitive salary;",
        //         "Additional medical insurance;",
        //         "Sports card;",
        //         "20 days paid leave + 1 day after each year to total of 24 days;",
        //         "Friendly environment with growth opportunities;",
        //         "Udemy account, Free certification cources and certification exams."
        //     ],
        //     hiringProcessSteps: [
        //         "Technical interview with small task;",
        //         "Interview with HR for cultural fit;",
        //         "Feedback within 5 working days."
        //     ],
        //     acceptApplicationsUntil: "15/01/2025"
        // }
    ]

    function expandCollapseForm(): void {
        if (formElementRef.current.classList.contains('collapsed')) {
            formElementRef.current.classList.remove('collapsed');
            formElementRef.current.classList.add('expanded');
            expandBtnRef.current.classList.remove('d-none');
            collapseBtnRef.current.classList.add('d-none');
        } else {
            formElementRef.current.classList.remove('expanded');
            formElementRef.current.classList.add('collapsed');
            expandBtnRef.current.classList.add('d-none');
            collapseBtnRef.current.classList.remove('d-none');
        }
    }

    useEffect(() => {
        document.title = phrases[36];
    }, [phrases]);

    return <>
        {
            positions.length > 0 
                ? positions.map((position: IPosition) => {
                    return <section key={uuid()} className='card-component__outter-container'>
                        <h1 className='job-title'>{position.title}</h1>
                        <small className='apply-until'>{phrases[126]}
                            <span className='fa-icon-red hourglass'>
                                <FontAwesomeIcon icon={faHourglassHalf} className='fa-icon-red'></FontAwesomeIcon> {position.acceptApplicationsUntil}
                            </span>
                        </small>
                        <article>
                            <p>{position.jobDescription}</p>
                            <p>{position.projectDescription}</p>
                            <p>{phrases[127]}</p>
                            <ul>
                                {
                                    position.requiredSkills.map((skill: string) => {
                                        return <li key={uuid()}>
                                            <FontAwesomeIcon icon={faSquareCheck} className='fa-icon-green'></FontAwesomeIcon> {skill}
                                        </li>
                                    })
                                }
                            </ul>
                            <p>{phrases[128]}</p>
                            <ul>
                                {
                                    position.niceToHaveSkills.map((skill: string) => {
                                        return <li key={uuid()}>
                                            <FontAwesomeIcon icon={faHandPeace} className='fa-icon-gold'></FontAwesomeIcon> {skill}
                                        </li>
                                    })
                                }
                            </ul>
                            <p>{phrases[129]}</p>
                            <ul>
                                {
                                    position.advantages.map((advantage: string) => {
                                        return <li key={uuid()}>
                                            <FontAwesomeIcon icon={faCircleUp} className='fa-icon-red'></FontAwesomeIcon> {advantage}
                                        </li>
                                    })
                                }
                            </ul>
                            <p>{phrases[130]}</p>
                            <ul>
                                {
                                    position.offerings.map((offer: string) => {
                                        return <li key={uuid()}>
                                            <FontAwesomeIcon icon={faStar} className='fa-icon-orange'></FontAwesomeIcon> {offer}
                                        </li>
                                    })
                                }
                            </ul>
                            <p>{phrases[131]}</p>
                            <ul>
                                {
                                    position.hiringProcessSteps.map((step: string, index: number) => {
                                        return <li key={uuid()}>
                                            { 
                                                index !== position.hiringProcessSteps.length - 1 
                                                    ? <FontAwesomeIcon icon={faPersonWalkingArrowRight} className='fa-icon-green'></FontAwesomeIcon>
                                                    : <FontAwesomeIcon icon={faFlagCheckered} className='finish-flash'></FontAwesomeIcon>
                                            } {step} 
                                        </li>
                                    })
                                }
                            </ul>
                            <p>{phrases[132]}</p>
                        </article>
                        <div className='form-controls-container'>
                            <Button 
                                icon="pi pi-angle-double-up"
                                iconPos="right"
                                label={phrases[124]}
                                size="small"
                                rounded
                                onClick={expandCollapseForm}
                                className='expand-btn d-none'
                                ref={expandBtnRef}
                            />
                            <Button 
                                icon="pi pi-angle-double-down"
                                iconPos="right"
                                label={phrases[124]}
                                size="small"
                                rounded
                                onClick={expandCollapseForm}
                                className='collapse-btn'
                                ref={collapseBtnRef}
                            /> 
                        </div>
                        <div className='apply-form-container'>
                            <ApplyFormComponent elementRef={formElementRef} jobTitle={position.title}/>
                        </div>
                    </section>
                })
                : <div id="no-available-positions">
                    <h1>{phrases[125]}</h1>
                    <div className='form-controls-container'>
                        <Button 
                            icon="pi pi-angle-double-up"
                            iconPos="right"
                            label={phrases[124]}
                            size="small"
                            rounded
                            onClick={expandCollapseForm}
                            className='expand-btn d-none'
                            ref={expandBtnRef}
                        />
                        <Button 
                            icon="pi pi-angle-double-down"
                            iconPos="right"
                            label={phrases[124]}
                            size="small"
                            rounded
                            onClick={expandCollapseForm}
                            className='collapse-btn'
                            ref={collapseBtnRef}
                        /> 
                    </div>
                    <div className='apply-form-container'>
                        <ApplyFormComponent elementRef={formElementRef} jobTitle={`no-available-position`}/>
                    </div>
                </div>
        }
    </>
}

export default OpenPositionsComponent
